
import React, { useState } from 'react';
import { Rate } from 'antd';
import ReviewModal from './ReviewModal'; 

const RateProduct = ({ productDetails, currentValue, setCurrentValue, onRatingSubmit, isRatingSubmitted, setIsRatingSubmitted }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  // Define error state internally - don't rely on parent component
  const [ratingError] = useState("");

  // Open the Review Modal with the selected rating when clicking on stars
  const handleChangeRate = (value) => {
    setCurrentValue(value);
    setIsModalOpen(true);
  };

  const handleWriteReviewClick = () => {
    setIsModalOpen(true);
  };
  

  return (
    <>
      <div className="rate-product col-lg-6 col-12 text-center border-start border-lg-0 ps-lg-4 mt-3">
        <p>Rate the product</p>
        <Rate
          onChange={handleChangeRate}
          value={currentValue !== null ? currentValue : 0}
          className="custom-rate"
        />

        {/*Error Message*/}
        {ratingError && (
          <div className="rating-error text-danger mt-2">
            <strong>{ratingError}</strong>
          </div>
        )}

        <div className="submitted-rating-container">
          {isRatingSubmitted && (
            <p className="text-success">
              <strong>Rating submitted</strong>
            </p>
          )}
        </div>

        <p>Have something to say?</p>
        <button
          className="btn btn-primary full-width-btn"
          onClick={handleWriteReviewClick}
        >
          Write a review
        </button>
      </div>

      {isModalOpen && (
        <ReviewModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          onSubmit={() => {
            setIsModalOpen(false);
            //Only submit is there is a rating
            if (currentValue > 0) {
              onRatingSubmit(); // Call to refresh the product details and set "Rating submitted"
            }
          }}
          product={productDetails}
          currentValue={currentValue}
          setCurrentValue={setCurrentValue}
        />
      )}
    </>
  );
};

export default RateProduct;
